import css from 'styled-jsx/css';

const styles = css.global`#c2c-conteudos {
  background-color: #FBFBFB;
  padding-top: 32px;
  padding-bottom: 40px;
}

#c2c-conteudos .is-desk {
  display: none;
}

#c2c-conteudos .is-mobi {
  overflow: hidden;
}

#c2c-conteudos .ctn-home-24 {
  position: relative;
}

#c2c-conteudos .c2c-conteudos-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 16px;
}

#c2c-conteudos .c2c-conteudos-slide {
  display: flex;
  justify-content: center;
  margin-right: 16px;
  margin-left: 0;
  flex: 0 0 272px;
}

#c2c-conteudos .c2c-conteudos-card {
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 272px;
  min-height: 348px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #CCC;
}

#c2c-conteudos picture {
  width: 100%;
}

#c2c-conteudos img {
  width: 100%;
  height: 189px;
  object-fit: cover;
  border-radius: 4px;
}

#c2c-conteudos .c2c-conteudos-card-textos {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 8px 16px 11px;
}

#c2c-conteudos .c2c-conteudos-slide-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

#c2c-conteudos .c2c-conteudos-slide-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#c2c-conteudos .custom-carousel.embla {
  margin-bottom: 18px;
}


#c2c-conteudos .home-pagination {
  width: 100%;
  max-width: 288px;
  margin-left: auto;
  margin-right: auto;
}

#c2c-conteudos .home-pagination .enable-mobile-arrows {
  height: 24px;
  width: 24px;
  background-size: 24px 24px;
}

@media (min-width: 992px) {

  #c2c-conteudos { 
    padding-top: 70px;
    padding-bottom: 88px;
  }

  #c2c-conteudos .is-mobi {
    display: none;
  }

  #c2c-conteudos .is-desk {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto;
  }

  #c2c-conteudos .cards-desk {
    display: flex;
    justify-content: space-between;
  }

  #c2c-conteudos .c2c-conteudos-card {
    width: 100%;
    max-width: 379px;
  }

  #c2c-conteudos .c2c-conteudos-card-textos {
    padding: 8px 16px 32px;
    /* height: 178px; */
  }

}`;

export default styles;